import styled from 'styled-components';
import { Typography } from '../../global/theme';

export const BackArrowIcon = styled.div`
  opacity: 0;
  visibility: hidden;
`;

export const TaskLinkPreviewMainDiv = styled.div`
  display: flex;
  margin-top: 12px;
  cursor: pointer;
  max-width: fit-content;
`;

export const TaskLinkContainer = styled.div`
  background: var(--background-secondary);
  border-radius: 6px;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 0.5px solid var(--border-primary);
  :hover {
    ${BackArrowIcon} {
      opacity: 1;
      visibility: visible;
    }
  }
`;

export const TaskLinkContent = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 8px;
  gap: 8px;
  border-bottom: 0.5px solid var(--border-primary);
`;

export const TaskLinkWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 4px;
`;

export const TaskProjectName = styled.div`
  color: var(--text-secondary);
  ${Typography.body_md}
`;

export const TaskTitle = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--text-primary);
  ${Typography.body_md_medium}
`;

export const IconDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  cursor: pointer;
  svg {
    fill: var(--text-secondary);
  }
  :hover {
    background-color: var(--neutral-secondary);
    border-radius: 6px;
    svg {
      fill: var(--text-primary);
    }
  }
`;

export const Dropdiv = styled.div`
  .active-dropdown {
    background-color: var(--neutral-secondary);
    border-radius: 6px;
  }
`;

export const TaskTabSection = styled.div`
  display: flex;
  gap: 20px;
`;

export const TaskStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  &.task-assignee {
    img {
      max-width: 16px;
      height: 16px;
      margin-top: 0;
    }
  }
`;

export const AvtarDiv = styled.div`
  display: flex;
  align-items: center;
`;
